import React from "react";
import { useNavigate } from "react-router-dom";
import Page from "components/Page";
import SectionCard from "components/SectionCard";
import MfaEnroll from "components/MfaEnroll";
import { useProfile } from "context/ProfileContext";

export default function MfaRequired() {
  const navigate = useNavigate();
  const { refreshProfile, mfaRequirement } = useProfile();

  const requiredOrgNames = (mfaRequirement?.requiredOrgs || [])
    .map((org) => org.name)
    .filter(Boolean);

  const handleEnrolled = async () => {
    await refreshProfile();
    navigate("/dashboard", { replace: true });
  };

  return (
    <Page title="MFA Required">
      <div className="max-w-3xl space-y-6">
        <SectionCard title="Multi-Factor Authentication Required">
          <div className="mb-4 space-y-2 text-sm text-muted">
            <p>
              Your organization requires multi-factor authentication before you
              can continue using Compass.
            </p>

            {requiredOrgNames.length > 0 && (
              <p>
                Required by:{" "}
                <span className="font-medium text-app">
                  {requiredOrgNames.join(", ")}
                </span>
              </p>
            )}
          </div>

          <MfaEnroll requiredMode onEnrolled={handleEnrolled} />
        </SectionCard>
      </div>
    </Page>
  );
}
